import { render, staticRenderFns } from "./activity-short-info.vue?vue&type=template&id=4c4ac387&scoped=true&"
import script from "./activity-short-info.ts?vue&type=script&lang=ts&"
export * from "./activity-short-info.ts?vue&type=script&lang=ts&"
import style0 from "./activity-short-info.scss?vue&type=style&index=0&id=4c4ac387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ac387",
  null
  
)

export default component.exports